
export interface AccessibilityPreferences {
  vision: Array<string>;
  hearing: Array<string>;
  physical: Array<string>;
  cognitive: Array<string>;
}

export const visionOptions = [
  {name: 'fontSize', displayName: 'I would like to change the font size'},
  {name: 'highContrastMode', displayName: 'I would like to change the font color (high contrast mode)'},
  {name: 'screenReader', displayName: 'I would like to use a screen reader'},
  {name: 'personRead', displayName: 'I would like a person to read the text to me'}
];

export const hearingOptions = [
  {name: 'volume', displayName: 'I would like to turn up the volume'},
  {name: 'closedCaptions', displayName: 'I would like to turn on closed captions'},
  {name: 'hapticFeedback', displayName: 'I would like to use haptic feedback (vibrations) instead of audio cues'}
];

export const physicalOptions = [
  {name: 'buttonSize', displayName: 'I would like to increase the size of the buttons'},
  {name: 'alternativeKeyboard', displayName: `I have an alternative keyboard I'd like to connect instead`},
  {name: 'voiceCommands', displayName: 'I would like to navigate the survey using voice commands instead of the touch screen'},
];

export const cognitiveOptions = [
  {name: 'textToSpeech', displayName: 'I would like the questions to be read to me using text-to-speech'},
  {name: 'personToReadText', displayName: 'I would like a person to read the text to me'},
  {name: 'speakAnswers', displayName: 'I would like to speak my answers instead of typing them'}
];
